module.exports = __webpack_public_path__ + "static/media/UserCreateSuccess.f901d7dd.svg";